import Utils from "../utils/Utils";
import { isNullOrUndefined } from "util";
import { removeDuplicate } from "../../../modules/toolbox/array";

var AnalyticsUtils = {
  isAnalytics: function() {
    if (typeof analytics !== "undefined" && analytics != null) {
      return true;
    }
    return false;
  },

  sendPage: function(properties, options) {
    properties = addMedium(properties);
    let name = properties.path ? properties.path : null;
    if (name) {
      analytics.page(name, properties, options);
    } else {
      analytics.page(properties, options);
    }
  },

  analytics: function() {
    if (AnalyticsUtils.isAnalytics()) {
      return {
        track: (event, _properties) => {
          if (
            typeof adminLevel === "undefined" ||
            (typeof adminLevel !== "undefined" && adminLevel !== 1)
          ) {
            AnalyticsUtils.ready(async options => {
              let properties = _properties ? _properties : {};
              properties = await addAccountUid(properties);
              properties = addMedium(properties);
              analytics.track(event, properties, options);
            });
          }
        },
        page: _properties => {
          if (
            typeof adminLevel === "undefined" ||
            (typeof adminLevel !== "undefined" && adminLevel !== 1)
          ) {
            AnalyticsUtils.ready(async options => {
              let properties = _properties ? _properties : {};
              properties = await addAccountUid(properties);
              if (!properties.account_uid) {
                let dictIdInstitutionsToAccountuids = await getDictIdInstitutionsToAccountuids();
                let allAccountuids = Object.values(dictIdInstitutionsToAccountuids);
                let allDuplicatesRemovedAccountuids = removeDuplicate(allAccountuids);
                let allDuplicatesRemovedAccountuidsLength = allDuplicatesRemovedAccountuids.length;
                if (allDuplicatesRemovedAccountuidsLength > 0) {
                  for (i = 0; i < allDuplicatesRemovedAccountuidsLength; i++) {
                    let isAdmin = !isNullOrUndefined(adminId);
                    properties.account_uid =
                      (isAdmin ? "" : "v_") + allDuplicatesRemovedAccountuids[i];
                    AnalyticsUtils.sendPage(properties, options);
                  }
                } else {
                  AnalyticsUtils.sendPage(properties, options);
                }
              } else {
                AnalyticsUtils.sendPage(properties, options);
              }
            });
          }
        },
        group: (groupId, _traits) => {
          if (
            typeof adminLevel === "undefined" ||
            (typeof adminLevel !== "undefined" && adminLevel !== 1)
          ) {
            AnalyticsUtils.ready(async options => {
              let traits = _traits ? _traits : {};
              traits = await addAccountUid(traits);
              analytics.group(groupId, traits, options);
            });
          }
        },
        identify: (userId, _traits) => {
          if (
            typeof adminLevel === "undefined" ||
            (typeof adminLevel !== "undefined" && adminLevel !== 1)
          ) {
            AnalyticsUtils.ready(async options => {
              let traits = _traits ? _traits : {};
              traits = await addAccountUid(traits);
              analytics.identify(userId, traits, options);
            });
          }
        }
      };
    } else {
      return {
        track: t => {
          console.error("no access to analytics; wanted to track : " + JSON.stringify(t, null, 2));
        },
        page: t => {
          console.error("no access to analytics; wanted to track : " + JSON.stringify(t, null, 2));
        },
        group: t => {
          console.error("no access to analytics; wanted to track : " + JSON.stringify(t, null, 2));
        },
        identify: t => {
          console.error("no access to analytics; wanted to track : " + JSON.stringify(t, null, 2));
        }
      };
    }
  },

  ready: function(callback) {
    analytics.ready(function() {
      var user = analytics.user();
      var traits = user.traits();

      var options = {};
      if (traits.type == "Vacataire") {
        options = {
          /*integrations: {
            Salesmachine: false
          }*/
        };
      }

      callback(options);
    });
  }
};

module.exports = AnalyticsUtils;
export default AnalyticsUtils;

function addMedium(properties) {
  /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
    ? (properties.medium = "app")
    : (properties.medium = "web");
  return properties;
}

async function addAccountUid(properties) {
  let idInstitution = properties.account_uid;
  if (!isNullOrUndefined(idInstitution)) {
    idInstitution = parseInt(idInstitution.toString().replace(/^\D+/g, ""));
    if (!isNaN(idInstitution)) {
      let dictIdInstitutionsToAccountuids = await getDictIdInstitutionsToAccountuids();
      if (dictIdInstitutionsToAccountuids && dictIdInstitutionsToAccountuids[idInstitution]) {
        let isAdmin = !isNullOrUndefined(adminId);
        properties.account_uid =
          (isAdmin ? "" : "v_") + dictIdInstitutionsToAccountuids[idInstitution];
      }
    }
  }

  return properties;
}

async function getDictIdInstitutionsToAccountuids() {
  try {
    if (!isNullOrUndefined(dictIdInstitutionsToAccountuids)) {
      return dictIdInstitutionsToAccountuids;
    } else {
      let result = await Utils.request("/v2/analytics/getDictIdInstitutionsToAccountuids", "GET");
      return result;
    }
  } catch (err) {
    if (err.responseText) {
      console.error(err.responseText);
    } else {
      console.error(err);
    }
  }
  return {};
}



// WEBPACK FOOTER //
// ./assets/react/utils/AnalyticsUtils.js